import { $authHost } from './index';

export const uploadInvoice = async (payload, files) => {
  const data = new FormData();
  data.append('type', payload.type);
  data.append('amount', payload.amount);
  data.append('date', payload.date);
  (files || []).forEach(f => data.append('files', f));
  const res = await $authHost.post('api/invoice', data);
  return res.data;
};

export const fetchInvoices = async (params = {}) => {
  const res = await $authHost.get('api/invoice', { params });
  return res.data;
};

export const fetchInvoiceStats = async (year) => {
  const res = await $authHost.get('api/invoice/stats', { params: { year } });
  return res.data;
};

export const importInvoiceItems = async (payload) => {
  const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
  const config = isFormData ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
  const res = await $authHost.post('api/invoice/import', payload, config);
  return res.data;
};

export const parseInvoiceImage = async (invoiceId, file) => {
  const data = new FormData();
  data.append('invoiceId', invoiceId);
  data.append('file', file);
  const res = await $authHost.post('api/invoice/parse', data);
  return res.data;
};
